(function () {
  'use strict';

  window.lzCorpEngravingValidate = function (text) {
    var value = String(text || '');
    if (!value.trim()) return { ok: true };
    var hasSurrogate = /[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(value);
    var hasSymbols = /[♡♥❤✨★☆✓✔✗✘●○◆◇■□▲△▼▽♫♪☀☁☂☃❄]/.test(value);
    if (hasSurrogate || hasSymbols) {
      return {
        ok: false,
        message: 'Engraving is laser-cut text/logo only — emoji and colour icons can’t be reproduced. Please remove them and try again.'
      };
    }
    return { ok: true };
  };

  function track(eventName, params) {
    var payload = Object.assign({ event: eventName }, params || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params || {});
      }
    } catch (e2) {}
  }

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function scrollToQuote() {
    var target = document.getElementById('lz-corp-quote');
    if (!target) return;
    if (document.documentElement.classList.contains('lz-corp-embed')) {
      try {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {}
      postEmbedHeight();
      return;
    }
    var top = target.getBoundingClientRect().top + window.pageYOffset - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function isEmbedMode() {
    try {
      return (
        document.documentElement.classList.contains('lz-corp-embed') ||
        /(?:^|[?&])embed=1(?:&|$)/.test(location.search)
      );
    } catch (e) {
      return false;
    }
  }

  function applyEmbedMode(root) {
    if (!isEmbedMode()) return false;
    document.documentElement.classList.add('lz-corp-embed');
    if (root) {
      root.setAttribute('data-lz-embed', '1');
      qsa(root, '.lz-corp-demo-banner').forEach(function (el) {
        el.hidden = true;
      });
    }
    return true;
  }

  function postEmbedHeight() {
    if (!isEmbedMode()) return;
    try {
      if (window.parent === window) return;
    } catch (e) {
      return;
    }
    var root = document.querySelector('[data-lz-corporate]');
    var el = root || document.body;
    var height = Math.ceil(el.getBoundingClientRect().height) + 32;
    height = Math.max(height, 720);
    try {
      window.parent.postMessage(
        { source: 'lz-corp-embed', type: 'lz-corp-embed-height', height: height },
        '*'
      );
    } catch (err) {}
  }

  function setCardImage(card, url) {
    if (!url) return;
    qsa(card, '[data-lz-product-img], [data-lz-product-img-panel]').forEach(function (img) {
      img.src = url;
    });
  }

  function refreshCardImage(card) {
    var on = qsa(card, '.lz-corp-colour.is-on');
    if (on.length) {
      var url = on[on.length - 1].dataset.image || card.dataset.featuredImage;
      setCardImage(card, url);
    } else {
      setCardImage(card, card.dataset.featuredImage);
    }
  }

  function updateCardPicksState(card) {
    var has = qsa(card, '.lz-corp-colour.is-on').length > 0;
    card.classList.toggle('has-picks', has);
  }

  function closeAllPanels(root, except) {
    qsa(root, '.lz-corp-product.is-open').forEach(function (card) {
      if (except && card === except) return;
      closePanel(card);
    });
  }

  function openPanel(card) {
    var panel = qs(card, '[data-lz-colour-panel]');
    var openBtn = qs(card, '[data-lz-open-product]');
    card.classList.add('is-open');
    if (panel) panel.hidden = false;
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    qsa(card, '.lz-corp-colour.is-preview').forEach(function (chip) {
      chip.classList.remove('is-preview');
    });
    updateAddColourButton(card);
    postEmbedHeight();
  }

  function closePanel(card) {
    var panel = qs(card, '[data-lz-colour-panel]');
    var openBtn = qs(card, '[data-lz-open-product]');
    card.classList.remove('is-open');
    if (panel) panel.hidden = true;
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    qsa(card, '.lz-corp-colour.is-preview').forEach(function (chip) {
      chip.classList.remove('is-preview');
    });
    updateAddColourButton(card);
    postEmbedHeight();
  }

  function updateAddColourButton(card) {
    var btn = qs(card, '[data-lz-add-colour]');
    if (!btn) return;
    var preview = qs(card, '.lz-corp-colour.is-preview');
    if (!preview) {
      btn.disabled = true;
      btn.textContent = 'Add to quote';
      btn.classList.remove('lz-corp-btn--muted');
      btn.classList.add('lz-corp-btn--teal');
      return;
    }
    btn.disabled = false;
    if (preview.classList.contains('is-on')) {
      btn.textContent = 'Remove from quote';
      btn.classList.remove('lz-corp-btn--teal');
      btn.classList.add('lz-corp-btn--muted');
    } else {
      btn.textContent = 'Add to quote';
      btn.classList.remove('lz-corp-btn--muted');
      btn.classList.add('lz-corp-btn--teal');
    }
  }

  function setPreviewColour(card, chip) {
    qsa(card, '.lz-corp-colour.is-preview').forEach(function (c) {
      c.classList.remove('is-preview');
    });
    if (chip) {
      chip.classList.add('is-preview');
      setCardImage(card, chip.dataset.image || card.dataset.featuredImage);
    }
    updateAddColourButton(card);
  }

  function rowKey(handle, colour) {
    return handle + '::' + colour;
  }

  function init(root) {
    if (!root || root.dataset.lzCorpReady) return;
    root.dataset.lzCorpReady = '1';

    applyEmbedMode(root);
    track('corporate_demo_page_view', { embed: isEmbedMode() });

    var formStarted = false;
    var panels = qsa(root, '[data-lz-panel]');
    var steps = qsa(root, '[data-lz-progress] li');
    var productsSummary = qs(root, '[data-lz-products-summary]');
    var productsHidden = qs(root, '[name="contact[products]"]');
    var bodyHidden = qs(root, '[name="contact[body]"]');
    var logoUrlInput = qs(root, '[name="contact[logo_url]"]');
    var logoStatus = qs(root, '[data-lz-logo-status]');
    var logoError = qs(root, '[data-lz-logo-error]');
    var logoFileInput = qs(root, '[data-lz-logo-file]');
    var logoDrop = qs(root, '[data-lz-logo-drop]');
    var logoDropIdle = qs(root, '[data-lz-drop-idle]');
    var logoDropPreview = qs(root, '[data-lz-drop-preview]');
    var logoDropMedia = qs(root, '[data-lz-drop-media]');
    var logoDropFilename = qs(root, '[data-lz-drop-filename]');
    var logoDropMeta = qs(root, '[data-lz-drop-meta]');
    var logoFilenameField = qs(root, '[data-lz-logo-filename]');
    var logoClearBtn = qs(root, '[data-lz-logo-clear]');
    var pendingLogoFile = null;
    var MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
    var LOGO_TYPES = /\.(png|jpe?g|svg|pdf|ai|eps|heic|heif)$/i;
    var reviewBox = qs(root, '[data-lz-review]');
    var notesField = qs(root, '[name="contact[engraving_message]"]');
    var notesError = qs(root, '[data-lz-notes-error]');
    var tray = qs(root, '[data-lz-selection-tray]');
    var trayList = qs(root, '[data-lz-tray-list]');
    var trayEmpty = qs(root, '[data-lz-tray-empty]');
    var trayClear = qs(root, '[data-lz-clear-selection]');
    var current = 0;
    var total = panels.length;
    var skipInitialScroll = true;
    var qtyStore = {};

    function quoteQuery(name) {
      return new RegExp('(?:^|[?&])' + name + '(?:=|&|$)').test(location.search);
    }

    function rememberQuoteSent() {
      try { sessionStorage.setItem('lz-corp-quote-sent', '1'); } catch (err) {}
    }

    function forgetQuoteSent() {
      try { sessionStorage.removeItem('lz-corp-quote-sent'); } catch (err) {}
    }

    function shouldShowThanks() {
      if (quoteQuery('quote=new')) {
        forgetQuoteSent();
        return false;
      }
      if (quoteQuery('quote=sent')) return true;
      var flagged = false;
      try { flagged = !!sessionStorage.getItem('lz-corp-quote-sent'); } catch (err) {}
      if (!flagged) return false;
      var nav = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav && (nav.type === 'reload' || nav.type === 'back_forward')) return true;
      return document.referrer.indexOf(location.pathname) !== -1;
    }

    function showQuoteThanks() {
      var head = qs(root, '[data-lz-quote-head]');
      var panel = qs(root, '[data-lz-quote-success]');
      var formEl = qs(root, 'form');
      if (head) head.hidden = true;
      if (formEl) formEl.hidden = true;
      if (panel) {
        panel.hidden = false;
        if (panel.scrollIntoView) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    if (shouldShowThanks()) {
      showQuoteThanks();
      return;
    }

    function markFormStart() {
      if (formStarted) return;
      formStarted = true;
      track('corporate_demo_form_start');
    }

    function selectedLineItems() {
      var items = [];

      qsa(root, '.lz-corp-product.is-selected[data-special="1"]').forEach(function (card) {
        items.push({
          title: card.dataset.title || '',
          handle: card.dataset.handle || '',
          colour: '',
          qty: 1,
          qtyValid: true,
          special: true
        });
      });

      qsa(root, '.lz-corp-product:not([data-special="1"])').forEach(function (card) {
        var title = card.dataset.title || '';
        var handle = card.dataset.handle || '';
        qsa(card, '.lz-corp-colour.is-on').forEach(function (chip) {
          var colour = chip.dataset.colour || '';
          var key = rowKey(handle, colour);
          var raw = String(qtyStore[key] != null ? qtyStore[key] : '').trim();
          var qty = parseInt(raw, 10);
          items.push({
            title: title,
            handle: handle,
            colour: colour,
            qty: qty,
            qtyValid: !isNaN(qty) && qty >= 1,
            special: false,
            key: key
          });
        });
      });

      return items;
    }

    function formatItem(i) {
      if (i.special) return i.title;
      if (i.colour) return i.title + ' / ' + i.colour + ' x' + i.qty;
      return i.title + ' x' + i.qty;
    }

    function renderTray() {
      if (!tray || !trayList) return;
      var all = selectedLineItems();
      var items = all.filter(function (i) { return !i.special; });
      var hasSpecial = all.some(function (i) { return i.special; });

      tray.hidden = items.length === 0 && !hasSpecial;
      if (trayEmpty) trayEmpty.hidden = items.length > 0;
      if (trayClear) trayClear.hidden = items.length === 0;

      trayList.innerHTML = '';
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'lz-corp-tray__row';
        li.dataset.key = item.key;

        var label = document.createElement('span');
        label.className = 'lz-corp-tray__label';
        label.textContent = item.title + (item.colour ? ' · ' + item.colour : '');

        var qtyWrap = document.createElement('label');
        qtyWrap.className = 'lz-corp-tray__qty';
        qtyWrap.innerHTML = '<span>Qty</span>';
        var input = document.createElement('input');
        input.type = 'number';
        input.min = '1';
        input.step = '1';
        input.placeholder = 'Qty';
        input.setAttribute('data-lz-qty', '');
        input.value = qtyStore[item.key] != null ? qtyStore[item.key] : '';
        input.addEventListener('click', function (e) { e.stopPropagation(); });
        input.addEventListener('input', function () {
          qtyStore[item.key] = input.value;
          markFormStart();
          syncProductsField(false);
        });
        input.addEventListener('change', function () {
          qtyStore[item.key] = input.value;
          markFormStart();
          syncProductsField(false);
        });
        qtyWrap.appendChild(input);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'lz-corp-tray__remove';
        remove.setAttribute('aria-label', 'Remove');
        remove.textContent = 'Remove';
        remove.addEventListener('click', function () {
          var card = qsa(root, '.lz-corp-product').find(function (c) {
            return c.dataset.handle === item.handle;
          });
          if (card) {
            var chip = qsa(card, '.lz-corp-colour').find(function (c) {
              return c.dataset.colour === item.colour;
            });
            if (chip) chip.classList.remove('is-on');
            updateCardPicksState(card);
            refreshCardImage(card);
          }
          delete qtyStore[item.key];
          syncProductsField(true);
        });

        li.appendChild(label);
        li.appendChild(qtyWrap);
        li.appendChild(remove);
        trayList.appendChild(li);
      });
    }

    function syncProductsField(rebuildTray) {
      if (rebuildTray !== false) renderTray();
      var items = selectedLineItems().filter(function (i) {
        return i.special || i.qtyValid;
      });
      var text = items.length ? items.map(formatItem).join('; ') : '';
      if (productsHidden) productsHidden.value = text;
      if (productsSummary) {
        productsSummary.textContent = text || 'Open a product, pick colour(s), then enter quantity in Your selection.';
      }
      return items;
    }

    function clearAllSelections() {
      qsa(root, '.lz-corp-colour.is-on').forEach(function (chip) {
        chip.classList.remove('is-on');
      });
      qsa(root, '.lz-corp-product:not([data-special="1"])').forEach(function (card) {
        updateCardPicksState(card);
        refreshCardImage(card);
        closePanel(card);
      });
      qsa(root, '.lz-corp-product.is-selected[data-special="1"]').forEach(function (card) {
        card.classList.remove('is-selected');
      });
      qtyStore = {};
      syncProductsField(true);
    }

    function showPanel(index) {
      current = Math.max(0, Math.min(index, total - 1));
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === current);
      });
      steps.forEach(function (step, i) {
        step.classList.toggle('is-active', i === current);
        step.classList.toggle('is-done', i < current);
      });
      if (current === total - 1) buildReview();
      if (skipInitialScroll) {
        skipInitialScroll = false;
        postEmbedHeight();
        return;
      }
      scrollToQuote();
      postEmbedHeight();
    }

    function submittedStamp() {
      try {
        var parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Africa/Johannesburg',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }).formatToParts(new Date());
        var get = function (type) {
          var part = parts.filter(function (p) { return p.type === type; })[0];
          return part ? part.value : '';
        };
        return get('day') + ' ' + get('month') + ' ' + get('year') + ', ' + get('hour') + ':' + get('minute') + ' SAST';
      } catch (err) {
        return new Date().toISOString();
      }
    }

    function stampSubmitted() {
      var stamp = submittedStamp();
      var field = qs(root, '[name="contact[submitted_at]"]');
      if (field) field.value = stamp;
      if (bodyHidden && bodyHidden.value) {
        if (/^Submitted: /m.test(bodyHidden.value)) {
          bodyHidden.value = bodyHidden.value.replace(/^Submitted: .*$/m, 'Submitted: ' + stamp);
        } else {
          bodyHidden.value += '\nSubmitted: ' + stamp;
        }
      }
      return stamp;
    }

    function buildReview() {
      if (!reviewBox) return;
      var company = (qs(root, '[name="contact[company]"]') || {}).value || '';
      var name = (qs(root, '[name="contact[name]"]') || {}).value || '';
      var email = (qs(root, '[name="contact[email]"]') || {}).value || '';
      var phone = (qs(root, '[name="contact[phone]"]') || {}).value || '';
      var sides = (qs(root, '[name="contact[engraving_sides]"]:checked') || {}).value || '';
      var method = (qs(root, '[name="contact[branding_method]"]:checked') || {}).value || '';
      var message = (qs(root, '[name="contact[engraving_message]"]') || {}).value || '';
      var use = (qs(root, '[name="contact[gift_or_resell]"]:checked') || {}).value || '';
      var logo = logoUrlInput ? logoUrlInput.value : '';
      var logoName = logoFilenameField ? logoFilenameField.value : '';
      var logoLabel = logo
        ? '<a href="' + escAttr(logo) + '" target="_blank" rel="noopener">' + esc(logo) + '</a>'
        : (logoName ? esc(logoName) + ' (uploads with this request)' : 'Not provided');
      var items = syncProductsField(false);
      var submitted = stampSubmitted();

      reviewBox.innerHTML =
        '<dl class="lz-corp-review">' +
        '<dt>Company</dt><dd>' + esc(company) + '</dd>' +
        '<dt>Contact</dt><dd>' + esc(name) + ' · ' + esc(email) + ' · ' + esc(phone) + '</dd>' +
        '<dt>Products</dt><dd>' + esc(items.map(formatItem).join(', ') || '—') + '</dd>' +
        '<dt>Branding</dt><dd>' + esc(method || '—') + (sides ? ' — ' + esc(sides) : '') + (message ? ' — ' + esc(message) : '') + '</dd>' +
        '<dt>Use</dt><dd>' + esc(use) + '</dd>' +
        '<dt>Logo</dt><dd>' + logoLabel + '</dd>' +
        '</dl>';

      if (bodyHidden) {
        bodyHidden.value = [
          'Printing and engraving quote request',
          'Company: ' + company,
          'Contact: ' + name + ' | ' + email + ' | ' + phone,
          'Products: ' + (items.map(formatItem).join('; ') || 'none'),
          'Sides: ' + sides,
          'Branding method: ' + (method || 'none'),
          'Message: ' + message,
          'Gift or resell: ' + use,
          'Logo URL: ' + (logo || 'none'),
          'Logo file: ' + (logoName || 'none'),
          'Submitted: ' + submitted
        ].filter(Boolean).join('\n');
      }
    }

    function esc(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function escAttr(str) {
      return esc(str).replace(/'/g, '&#39;');
    }

    function isLaserMethod() {
      var method = qs(root, '[name="contact[branding_method]"]:checked');
      return !method || method.value === 'Laser engraving';
    }

    function validateNotes() {
      if (!notesField || !isLaserMethod()) {
        if (notesError) {
          notesError.hidden = true;
          notesError.textContent = '';
        }
        return true;
      }
      var result = window.lzCorpEngravingValidate(notesField.value);
      if (notesError) {
        notesError.hidden = result.ok;
        notesError.textContent = result.ok ? '' : result.message;
      }
      if (!result.ok) {
        notesField.focus();
        return false;
      }
      return true;
    }

    function validateStep(index) {
      if (index === 0) {
        var required = ['contact[company]', 'contact[name]', 'contact[email]', 'contact[phone]'];
        for (var i = 0; i < required.length; i++) {
          var el = qs(root, '[name="' + required[i] + '"]');
          if (!el || !String(el.value || '').trim()) {
            if (el) el.focus();
            alert('Please complete company and contact details.');
            return false;
          }
        }
        var email = qs(root, '[name="contact[email]"]');
        if (email && email.value.indexOf('@') === -1) {
          email.focus();
          alert('Enter a valid work email.');
          return false;
        }
        return true;
      }
      if (index === 1) {
        var rawItems = selectedLineItems();
        var specialOnly = rawItems.some(function (i) { return i.special; });
        var colourLines = rawItems.filter(function (i) { return !i.special; });

        if (!rawItems.length) {
          alert('Select at least one product and colour, or Not sure / More than one type.');
          return false;
        }

        if (colourLines.length && colourLines.some(function (i) { return !i.qtyValid; })) {
          alert('Enter a quantity (1 or more) for each item in Your selection.');
          if (tray) tray.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return false;
        }

        if (!specialOnly && !colourLines.filter(function (i) { return i.qtyValid; }).length) {
          alert('Enter a quantity for each selected colour.');
          return false;
        }

        syncProductsField(false);
        return true;
      }
      if (index === 2) {
        var method = qs(root, '[name="contact[branding_method]"]:checked');
        var sides = qs(root, '[name="contact[engraving_sides]"]:checked');
        var use = qs(root, '[name="contact[gift_or_resell]"]:checked');
        if (!method || !sides || !use) {
          alert('Choose a branding method, which side to brand, and whether this is for gifting or reselling.');
          return false;
        }
        if (!validateNotes()) return false;
        return true;
      }
      return true;
    }

    qsa(root, '.lz-corp-product').forEach(function (card) {
      var isSpecial = card.getAttribute('data-special') === '1';
      var openBtn = qs(card, '[data-lz-open-product]');

      if (isSpecial) {
        var toggleSpecial = function () {
          markFormStart();
          card.classList.toggle('is-selected');
          syncProductsField(true);
          track('corporate_demo_product_select', {
            product: card.dataset.handle || card.dataset.title,
            selected: card.classList.contains('is-selected')
          });
        };
        card.addEventListener('click', toggleSpecial);
        return;
      }

      function toggleOpen() {
        markFormStart();
        var willOpen = !card.classList.contains('is-open');
        closeAllPanels(root, willOpen ? card : null);
        if (willOpen) {
          openPanel(card);
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } else {
          closePanel(card);
        }
      }

      if (openBtn) {
        openBtn.addEventListener('click', function (e) {
          e.preventDefault();
          toggleOpen();
        });
      }

      card.addEventListener('keydown', function (e) {
        if (e.target.closest('.lz-corp-colour') || e.target.closest('[data-lz-qty]') || e.target.closest('input')) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleOpen();
        }
        if (e.key === 'Escape') {
          closePanel(card);
        }
      });

      qsa(card, '[data-lz-close-product]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          closePanel(card);
          if (tray && !tray.hidden) {
            tray.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      });

      var addColourBtn = qs(card, '[data-lz-add-colour]');
      if (addColourBtn) {
        addColourBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          markFormStart();
          var preview = qs(card, '.lz-corp-colour.is-preview');
          if (!preview) return;
          var key = rowKey(card.dataset.handle || '', preview.dataset.colour || '');
          if (preview.classList.contains('is-on')) {
            preview.classList.remove('is-on');
            delete qtyStore[key];
            track('corporate_demo_product_select', {
              product: card.dataset.handle,
              colour: preview.dataset.colour,
              selected: false
            });
          } else {
            preview.classList.add('is-on');
            track('corporate_demo_product_select', {
              product: card.dataset.handle,
              colour: preview.dataset.colour,
              selected: true
            });
          }
          updateCardPicksState(card);
          updateAddColourButton(card);
          syncProductsField(true);
          postEmbedHeight();
        });
      }

      qsa(card, '.lz-corp-colour').forEach(function (chip) {
        chip.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          markFormStart();
          setPreviewColour(card, chip);
          track('corporate_demo_colour_preview', {
            product: card.dataset.handle,
            colour: chip.dataset.colour
          });
          postEmbedHeight();
        });
      });

      updateAddColourButton(card);
    });

    if (trayClear) {
      trayClear.addEventListener('click', function () {
        markFormStart();
        clearAllSelections();
      });
    }

    qsa(root, '[data-lz-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        markFormStart();
        if (!validateStep(current)) return;
        showPanel(current + 1);
      });
    });

    qsa(root, '[data-lz-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showPanel(current - 1);
      });
    });

    qsa(root, 'input, textarea, select').forEach(function (el) {
      el.addEventListener('focus', markFormStart, { once: true });
    });

    if (notesField) {
      notesField.addEventListener('input', function () {
        if (notesError && !notesError.hidden) validateNotes();
      });
    }

    var form = qs(root, 'form');

    function uploadLogoThenSubmit(formEl) {
      setLogoStatus('Uploading logo…');
      setLogoError('');
      var submitBtn = qs(formEl, '[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      var body = new FormData();
      body.append('file', pendingLogoFile);
      fetch(window.location.origin + '/apps/ecomposer-visual-page-builder/contact-form', {
        method: 'POST',
        body: body
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        if (data && data.status === 'success' && data.src_file) {
          if (logoFileInput && logoFileInput.parentNode) logoFileInput.parentNode.removeChild(logoFileInput);
          logoFileInput = null;
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'contact[File Upload]';
          hidden.value = data.src_file;
          formEl.appendChild(hidden);
          pendingLogoFile = null;
          formEl.dataset.lzLogoReady = '1';
          track('corporate_demo_logo_upload', { method: 'ecomposer' });
          buildReview();
          stampSubmitted();
          rememberQuoteSent();
          formEl.submit();
          return;
        }
        if (submitBtn) submitBtn.disabled = false;
        setLogoStatus('');
        setLogoError((data && data.message) ? ('Notice: ' + data.message) : 'Upload failed. Try again, or paste a link.');
        showPanel(3);
      }).catch(function () {
        if (submitBtn) submitBtn.disabled = false;
        setLogoStatus('');
        setLogoError('Upload failed. Try again, or paste a link.');
        showPanel(3);
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (form.dataset.lzLogoReady === '1') {
          track('corporate_demo_quote_submit');
          return;
        }
        for (var step = 0; step < 3; step++) {
          if (!validateStep(step)) {
            e.preventDefault();
            showPanel(step);
            return;
          }
        }
        syncProductsField(false);
        buildReview();
        stampSubmitted();
        if (pendingLogoFile) {
          e.preventDefault();
          uploadLogoThenSubmit(form);
          return;
        }
        if (logoFileInput) logoFileInput.removeAttribute('name');
        rememberQuoteSent();
        track('corporate_demo_quote_submit');
      });
    }

    function formatBytes(n) {
      if (n < 1024) return n + ' B';
      if (n < 1024 * 1024) return (n / 1024).toFixed(0) + ' KB';
      return (n / (1024 * 1024)).toFixed(1) + ' MB';
    }

    function setLogoError(msg) {
      if (!logoError) return;
      if (msg) {
        logoError.hidden = false;
        logoError.textContent = msg;
      } else {
        logoError.hidden = true;
        logoError.textContent = '';
      }
    }

    function setLogoStatus(msg) {
      if (logoStatus) logoStatus.textContent = msg || '';
    }

    function clearLogoFile() {
      pendingLogoFile = null;
      if (form) delete form.dataset.lzLogoReady;
      if (logoFileInput) {
        logoFileInput.value = '';
        logoFileInput.setAttribute('name', 'contact[File Upload]');
      }
      if (logoFilenameField) logoFilenameField.value = '';
      if (logoDropMedia) logoDropMedia.innerHTML = '';
      if (logoDropIdle) logoDropIdle.hidden = false;
      if (logoDropPreview) logoDropPreview.hidden = true;
      if (logoDrop) logoDrop.classList.remove('has-file', 'is-drag');
      setLogoError('');
      setLogoStatus('');
    }

    function showLogoPreview(file, dataUrl) {
      if (logoDropIdle) logoDropIdle.hidden = true;
      if (logoDropPreview) logoDropPreview.hidden = false;
      if (logoDrop) logoDrop.classList.add('has-file');
      if (logoDropFilename) logoDropFilename.textContent = file.name;
      if (logoDropMeta) logoDropMeta.textContent = formatBytes(file.size);
      if (logoDropMedia) {
        logoDropMedia.innerHTML = '';
        if (dataUrl && /^image\//.test(file.type)) {
          var img = document.createElement('img');
          img.src = dataUrl;
          img.alt = '';
          logoDropMedia.appendChild(img);
        } else {
          var badge = document.createElement('span');
          badge.className = 'lz-corp-drop__filebadge';
          badge.textContent = (file.name.split('.').pop() || 'FILE').toUpperCase();
          logoDropMedia.appendChild(badge);
        }
      }
    }

    function logoAllowed(file) {
      if (LOGO_TYPES.test(file.name || '')) return true;
      return /^(image\/(png|jpeg|svg\+xml|heic|heif)|application\/pdf)$/i.test(file.type || '');
    }

    function acceptLogoFile(file) {
      if (!file) return;
      markFormStart();
      setLogoError('');

      if (!logoAllowed(file)) {
        setLogoError('Please upload a PNG, JPG, SVG, PDF, AI, EPS, or HEIC file.');
        if (logoFileInput) logoFileInput.value = '';
        return;
      }
      if (file.size > MAX_UPLOAD_BYTES) {
        setLogoError('File is too large (max 10MB). Compress it or paste a Drive/Dropbox link below.');
        if (logoFileInput) logoFileInput.value = '';
        return;
      }

      pendingLogoFile = file;
      if (form) delete form.dataset.lzLogoReady;
      if (logoFilenameField) logoFilenameField.value = file.name;
      var previewUrl = /^image\//.test(file.type || '') ? URL.createObjectURL(file) : '';
      showLogoPreview(file, previewUrl);
      setLogoStatus('Logo ready: ' + file.name + '. It uploads when you send the quote.');
    }

    if (logoDrop && logoFileInput) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        logoDrop.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
          logoDrop.classList.add('is-drag');
        });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        logoDrop.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
          logoDrop.classList.remove('is-drag');
        });
      });
      logoDrop.addEventListener('drop', function (e) {
        var files = e.dataTransfer && e.dataTransfer.files;
        if (files && files[0]) acceptLogoFile(files[0]);
      });
      logoFileInput.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      logoFileInput.addEventListener('change', function () {
        if (logoFileInput.files && logoFileInput.files[0]) {
          acceptLogoFile(logoFileInput.files[0]);
        }
      });
    }

    if (logoClearBtn) {
      logoClearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearLogoFile();
      });
    }

    if (logoUrlInput) {
      logoUrlInput.addEventListener('change', function () {
        if (logoUrlInput.value) {
          track('corporate_demo_logo_upload', { method: 'manual' });
          setLogoStatus('Logo URL saved.');
        }
      });
    }

    qsa(document, '[href="#lz-corp-quote"]').forEach(function (a) {
      a.addEventListener('click', function () {
        markFormStart();
      });
    });

    syncProductsField(true);
    showPanel(0);

    if (isEmbedMode()) {
      postEmbedHeight();
      window.addEventListener('resize', postEmbedHeight);
      if (window.ResizeObserver && root) {
        try {
          var ro = new ResizeObserver(function () { postEmbedHeight(); });
          ro.observe(root);
        } catch (e) {}
      }
      setTimeout(postEmbedHeight, 400);
      setTimeout(postEmbedHeight, 1200);
    }
  }

  function boot() {
    applyEmbedMode(document.querySelector('[data-lz-corporate]'));
    qsa(document, '[data-lz-corporate]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
